<template>
    <hts-drawer
        v-model="visible"
        color="main"
        :rules="rulesCategoryRemooc"
        :width="40"
        :submit="handleSubmitFormEditRemoocCategory"
        :title="$t('labels.remoocModule.remoocCategory.edit')"
        :undo-enable="true"
        @close="closeOverSide"
        @undo="undo()">
        <hts-card :title="$t('labels.generalInformation')">
            <div class="grid gap-4">
                <hts-form-select
                    v-model="dataFormEditRemoocCategory.type"
                    v-model:text="dataFormEditRemoocCategory.name"
                    :label="$t('labels.remoocModule.containerCapacity')"
                    required
                    :items="towingCapacityList"
                    key-id="value"
                    key-label="label"
                    :color="props.color"
                    name="type"
                    prop="type" />
                <hts-form-input
                    v-model="dataFormEditRemoocCategory.wheelNumber"
                    :label="$t('labels.vehicleModule.category.wheelNumber')"
                    :color="props.color"
                    required
                    type="number"
                    name="vehicleModule.category.wheelNumber"
                    prop="vehicleModule.category.wheelNumber" />
                <hts-form-input
                    v-model="dataFormEditRemoocCategory.priceTires"
                    :label="$t('labels.vehicleModule.category.priceTires')"
                    :color="props.color"
                    required
                    type="number"
                    name="priceTires"
                    prop="priceTires" />
                <hts-form-input
                    v-model="dataFormEditRemoocCategory.depreciationTires"
                    :label="$t('labels.vehicleModule.category.depreciationTires')"
                    :color="props.color"
                    required
                    type="number"
                    name="depreciationTires"
                    prop="depreciationTires" />
                <hts-form-input
                    v-model="dataFormEditRemoocCategory.depreciationPeriodRemooc"
                    :label="$t('labels.depreciationPeriodRemoocByYear')"
                    :color="props.color"
                    required
                    type="number"
                    name="depreciationPeriodRemoocByYear"
                    prop="depreciationPeriodRemoocByYear" />
                <hts-form-input
                    v-model="dataFormEditRemoocCategory.priceLiquidation"
                    :label="$t('labels.priceLiquidation')"
                    :color="props.color"
                    required
                    type="number"
                    name="priceLiquidation"
                    prop="priceLiquidation" />
                <hts-form-input
                    v-model="dataFormEditRemoocCategory.depreciationRate"
                    :label="$t('labels.depreciationRateAmountYear')"
                    required
                    :color="props.color"
                    type="number"
                    name="depreciationRate"
                    prop="depreciationRate" />
                <hts-form-input
                    v-model="dataFormEditRemoocCategory.description"
                    :label="$t('labels.description')"
                    :color="props.color"
                    name="description"
                    prop="description" />
            </div>
        </hts-card>
    </hts-drawer>
</template>

<script setup lang="ts">
import form, { AxesType, TowingCapacity } from '../imports/remooc'
import { CoveringContainerLevel, GoodsTypes } from '../imports/form'

const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: String,
    default: 'small'
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  },
  infoRemoocCategory: {
    type: Object
  }
})

const emits = defineEmits(['close', 'refreshTables'])

const visible = ref(false)
const creating = ref(false)
const openEditRemoocCategory = () => {
  _init()
  nextTick(() => {
    visible.value = true
  })
}
defineExpose({
  openEditRemoocCategory
})
const closeOverSide = () => {
  visible.value = false
}

const dataFormEditRemoocCategory = reactive({ ...form.initRemoocCategory })
const towingCapacityList = [
  {
    value: 20,
    label: $t('labels.vehicleModule.20ft')
  },
  {
    value: 40,
    label: $t('labels.vehicleModule.40ft')
  },
  {
    value: 45,
    label: $t('labels.vehicleModule.45ft')
  }
]

watch(props, () => {
  _init()
})

const _init = () => {
  Object.assign(dataFormEditRemoocCategory, { ...props.infoRemoocCategory })
}
const undo = () => {
  dataFormEditRemoocCategory.name = ''
  dataFormEditRemoocCategory.type = undefined
  dataFormEditRemoocCategory.wheelNumber = undefined
  dataFormEditRemoocCategory.priceTires = undefined
  dataFormEditRemoocCategory.depreciationTires = undefined
  dataFormEditRemoocCategory.depreciationPeriodRemooc = null
  dataFormEditRemoocCategory.priceLiquidation = null
  dataFormEditRemoocCategory.depreciationRate = null
  dataFormEditRemoocCategory.description = ''
}

const handleSubmitFormEditRemoocCategory = () => {
  creating.value = true
  $api($url.vehicle.remoocCategory.edit, {
    uriParams: { id: props.infoRemoocCategory?._id },
    body: {
      ...dataFormEditRemoocCategory
    }
  })
    .then((data: any) => {
      const resData: any = data.data.value
      if (resData.success) {
        emits('refreshTables')
        process.client && $toast().success(resData.data)
        emits('close')
      }
      creating.value = false
      visible.value = false
    })
    .catch((e) => {
      creating.value = false
    })
}

const rulesCategoryRemooc = {
  depreciationPeriodRemoocByYear: 'min_value:1|integer',
  depreciationTires: 'min_value:1|integer',
  'vehicleModule.category.wheelNumber': 'required|min_value:1|integer',
  depreciationRate: 'required'
}
</script>
